(ns practitest.frontend.components.run-status
  (:require [reagent.core :as reagent]
            ["react-select" :default Select :refer [components]]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.lists :as lists]))

;; TODO: from backend ?
(def statuses-map
  {"PENDING"       {:label "Pending"
                    :icon  icons/three-dots
                    :color "var(--pt-color-status-pending)"
                    :class "status-pending"}
   "RUNNING"       {:label "Running"
                    :color "var(--pt-color-status-running)"
                    :class "status-running"
                    :icon  icons/icons-spinner}
   "PASSED"        {:label "Passed"
                    :color "var(--pt-color-status-passed)"
                    :class "status-passed"
                    :icon  icons/check-circle-fill}
   "FAILED"        {:label "Failed"
                    :color "var(--pt-color-status-failed)"
                    :class "status-failed"
                    :icon  icons/x-circle-fill}
   "CANCELED"      {:label "Canceled"
                    :class "status-canceled"
                    :icon  icons/slash-circle
                    :color "var(--pt-color-status-canceled)"}
   "ERROR"         {:label "Error"
                    :class "status-error"
                    :color "var(--pt-color-status-error)"
                    :icon  icons/exclamation-circle-fill}
   "NO RUN"        {:label "No Run"
                    :icon  icons/file-earmark
                    :color "var(--pt-color-status-no-run)"}
   "BLOCKED"       {:label "Blocked"
                    :color "var(--pt-color-status-blocked)"
                    :icon  icons/dash-circle}
   "NOT COMPLETED" {:label "Not Completed"
                    :color "var(--pt-color-status-not-completed)"
                    :icon  icons/file-earmark-medical}
   "N/A"           {:label "N/A"
                    :color "var(--pt-color-status-na)"
                    :icon  icons/not-applicable}})

(defn get-status-label
  [status]
  (when status
    (or (:label (get statuses-map status))
        (str "UNMAPPED STATUS " status))))

(defn get-status-icon
  [status]
  (when-let [icon (:icon (get statuses-map status))]
    [icon]))

(defn get-status-class
  [status]
  (:class (get statuses-map status)))

(defn get-status-color
  [status]
  (:color (get statuses-map status)))

(defn status-label
  [status]
  [:span.status
   ;; Support class/color styling
   (let [class (get-status-class status)]
     (if class
       {:class (get-status-class status)}
       {:style {:color (get-status-color status)}}))
   [:span.me-1 (get-status-icon status)]
   (get-status-label status)])
